<script lang="ts">
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';

  export let item;
  export let entryId;
</script>

<div class="ContentExplorerItem" data-entry-id={entryId}>
  <DynamicChildrenComponent children={[item]} />
</div>

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/tokens/generated-tokens/scss/_media_queries' as mediaQueries;

  .ContentExplorerItem {
    width: 100%;
    height: fit-content;

    :global(.RichTextFieldComponent) {
      display: flex;
      flex-direction: column;
      max-width: 100% !important;

      :global(.AproposImageComponent) {
        margin-bottom: var(--space-30);

        @include mediaQueries.at('medium') {
          margin-bottom: 0;
        }
      }
    }

    @include mediaQueries.at('medium') {
      padding-top: var(--space-10);
      border-top: 1px solid var(--color-gray-15);
    }
  }
</style>
